import { render, staticRenderFns } from "./marketingActive.vue?vue&type=template&id=e3f596bc&scoped=true"
import script from "./marketingActive.vue?vue&type=script&lang=ts"
export * from "./marketingActive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f596bc",
  null
  
)

export default component.exports